<template>
  <GridTable v-if="data.content" :columns="columns" :rows="[data.content]">
    <template #row="{row}">
      <GridTableCell>{{ formatDateTimeForLocale(row.created_at) }}</GridTableCell>
      <GridTableCell>{{ row.description }}</GridTableCell>
      <GridTableCell>{{ row.created_by.name }}</GridTableCell>
    </template>
  </GridTable>
</template>

<script>
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    GridTable,
    GridTableCell
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Date', width: '150px', align: 'center' },
        { label: 'Description', width: '1fr' },
        { label: 'By', width: '1fr' }
      ]
    }
  }
}
</script>
